import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import i18n from "../../lib/i18n";
import { RootState } from "../../state";
import { UnknownError } from "../../common/actions/VisitApi";
import { isFailure } from "../../common/actions/VisitApi";
import { requestToCreateBookmark, requestToDeleteBookmark } from "../api";

const actionCreator = actionCreatorFactory("PROJECT_BOOKMARKS");

export const createBookmark = actionCreator.async<RootState, EntityId, null, UnknownError>("CREATED");
export const createBookmarkWorker = bindThunkAction(createBookmark, async (params, dispatch, getState) => {
  const req = requestToCreateBookmark(params);
  const res = await dispatch(req);
  const locale = getState().auth.locale;
  if (isFailure(res)) {
    (window as any).notify_bar(i18n.translate("notify_bar.network_error", { locale }), true);
    throw res.payload.body;
  }
  (window as any).notify_bar(i18n.translate("wanteds_index.added_to_bookmark", { locale }));
  return null;
});

export const deleteBookmark = actionCreator.async<RootState, EntityId, null, UnknownError>("DELETED");
export const deleteBookmarkWorker = bindThunkAction(deleteBookmark, async (params, dispatch, getState) => {
  const req = requestToDeleteBookmark(params);
  const res = await dispatch(req);
  const locale = getState().auth.locale;
  if (isFailure(res)) {
    (window as any).notify_bar(i18n.translate("notify_bar.network_error", { locale }), true);
    throw res.payload.body;
  }
  return null;
});



// WEBPACK FOOTER //
// ./frontend/src/project_bookmarks/actions/index.ts